module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-italy.acc90fe9.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-italy.png
// module id = 2628
// module chunks = 11